import { VideoCard } from "../components/VideoCard";
import { justiciaVideos } from "../data/content";
import type { VideoItem } from "../types";

export function JusticiaSection({ openVideo }: { openVideo: (v: VideoItem) => void }) {
	return (
		<>
			<div className="justice-banner" id="justicia">
				<div className="justice-banner__inner reveal">
					<div className="justice-banner__eyebrow">Exigimos justicia</div>
					<h2 className="justice-banner__heading">
						Justicia para Stefanny Daniela Mora Nieto, Dorian y Damián Quintanar
						Mora.
					</h2>
					<p className="justice-banner__text">
						Su vida no puede ni debe ser olvidada. Stefanny tocó muchos corazones y
						fue ampliamente reconocida en universidades, colectivas, movimientos,
						instituciones y medios de comunicación. Su legado debe ser recordado y
						honrado. Su vida y la de sus bebés no puede quedar impune. Seguiremos
						buscando justicia y haciendo su trabajo conocido, sin importar el
						tiempo.
					</p>
				</div>
			</div>

			<section className="section">
				<div className="content-wrap--wide">
					<div
						className="video-grid"
						style={{ gridTemplateColumns: "repeat(2, 1fr)", maxWidth: 760, margin: "0 auto" }}
					>
						{justiciaVideos.map((v, i) => (
							<VideoCard item={v} onOpen={openVideo} key={i} />
						))}
					</div>
				</div>
			</section>
		</>
	);
}
